import $ from '@nuskin/nuskinjquery';
import {storage}     from '@nuskin/ns-util';
import LtoCart     from './ltoCart.js';
import LtoCartItem from './ltoCartItem.js';

let _localStorageCartService = function(){
    "use strict";

    let CART_STORAGE_KEY = storage.metadata.CART_SERVICE;

    // ---------------------------------------------
    //
    //        Define all public methods.
    //
    // ---------------------------------------------
    let publicMethods = {
        getCart: function(){
            let cart = null;
            let cartData = getStoredCart();
            if (cartData !== null){
                let cartItem;
                cart = new LtoCart();

                if (cartData.products !== null){
                    for (let i=0;i<cartData.products.length;i++){
                        cartItem = new LtoCartItem(cartData.products[i].sku, cartData.products[i].qty, cartData.products[i].maxQty);
                        cart.addCartItem(cartItem);
                    }
                }
            }
            return cart;
        },
        setCart: function(cart){
            if (cart != null && cart instanceof LtoCart){
                writeCartToStorage(cart.toJSON());
            } else{
                writeCartToStorage(cart);
            }
        },
        resetCartCookies: function(){
            writeCartToStorage(null);
            if (storage !== undefined) {
                storage('simpleCart_items', null);
            }
        }
    };

    // ---------------------------------------------
    //
    //        Define all private methods.
    //
    // ---------------------------------------------
    function getStoredCart(){
        let cart = null;
        if ($.cookie !== undefined){
            let cookieVal = $.cookie(CART_STORAGE_KEY);
            if (cookieVal !== null && cookieVal !== undefined) {
                cart = JSON.parse(cookieVal);
            }
        }
        return cart;
    }

    function writeCartToStorage(cart){
        if ($.cookie !== undefined) {
            let options = {path: '/'};
            if (cart !== null){
                $.cookie(CART_STORAGE_KEY, JSON.stringify(cart), options);
            }
            else {
                $.cookie(CART_STORAGE_KEY, null, options);
            }
        }
    }

    return publicMethods;
}();

let localStorageCartService = _localStorageCartService;

export default localStorageCartService;
